import styled from 'styled-components';

export const ListCard = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 24px;

    .partner-name {
        font-size: 16px;
        color: #2B3A54;
    }

    .partner-details {
        padding-top: 10px;
    }

    .partner-description {
        font-size: 12px;
        color: #626E82;
    }

    .partner-description-val {
        font-size: 12px;
        color: #626E82;
    }
`;

export const MessageContainer = styled.div`
    font-size: 11px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #6c7485;
    margin-top: 12px;
`